module.exports = __webpack_public_path__ + "img/Butterfly_00180.583392aa.png";